/**
 * Перевіряє, чи відрізняються `form` від `original` за тими ключами,
 * що є у формі. Глибокого порівняння не робимо — рівні значення (
 * string/number/boolean/null) достатньо для наших форм-довідників.
 *
 * Якщо `original === null` (новий запис), вважаємо form брудним,
 * щоб не закрити випадково модалку з даними, які ще ніде не збережено.
 */
export function isDirty<T extends object>(
  form: T,
  original: Partial<T> | null,
): boolean {
  if (original === null) {
    // Новий запис — будь-яке непорожнє значення вважаємо «зміною».
    return Object.values(form).some((v) => v !== '' && v !== null && v !== false);
  }
  for (const key of Object.keys(form) as (keyof T)[]) {
    if ((form[key] ?? null) !== ((original[key] as T[keyof T] | undefined) ?? null)) {
      return true;
    }
  }
  return false;
}
